// import './App.css';

// function App() {
//   return (
//     <div className="layout">

//       {/* ===== Header ===== */}
//       <header className="header">
//         <div className="logo">MiniBlog</div>

//         <nav className="nav">
//           <a href="/">Home</a>
//           <a href="/blogs">Blogs</a>
//           <a href="/login" className="nav-btn">Login</a>
//         </nav>
//       </header>

//       {/* ===== Hero Section ===== */}
//       <section className="hero">
//         <div className="hero-left">
//           <h1>Publish Your Ideas With Confidence</h1>
//           <p>
//             MiniBlog helps you write, manage and share blogs with a clean and
//             distraction-free experience.
//           </p>

//           <div className="hero-actions">
//             <button className="btn primary">Start Writing</button>
//             <button className="btn outline">View Blogs</button>
//           </div>
//         </div>

//         <div className="hero-right">
//           <div className="hero-card">
//             <h3>✍️ Write Freely</h3>
//             <p>Simple editor with powerful features.</p>
//           </div>
//           <div className="hero-card">
//             <h3>📈 Grow Audience</h3>
//             <p>Reach more readers with modern tools.</p>
//           </div>
//         </div>
//       </section>

//       {/* ===== Features ===== */}
//       <section className="features">
//         <h2>Everything you need</h2>

//         <div className="feature-grid">
//           <div className="feature">
//             <h4>Fast Performance</h4>
//             <p>Optimized for speed and smooth experience.</p>
//           </div>

//           <div className="feature">
//             <h4>Secure Platform</h4>
//             <p>Industry-level authentication & protection.</p>
//           </div>

//           <div className="feature">
//             <h4>Clean UI</h4>
//             <p>Minimal design focused on content.</p>
//           </div>
//         </div>
//       </section>

//       {/* ===== CTA ===== */}
//       <section className="cta">
//         <h2>Start your journey today</h2>
//         <p>Create your first blog in seconds.</p>
//         <button className="btn primary">Get Started</button>
//       </section>

//       {/* ===== Footer ===== */}
//       <footer className="footer">
//         <p>© {new Date().getFullYear()} MiniBlog. All rights reserved.</p>
//       </footer>

//     </div>
//   );
// }

// export default App;

import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;